import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRequestList extends Layout {
	sourceLogReader: DataSource;
	tableRequestList: Table;
}
